import React from "react";
import { MapPin } from "lucide-react";

interface LocationTargetPreviewProps {
  location: {
    label: string;
    embedUrl: string;
  };
}

const LocationTargetPreview = ({ location }: LocationTargetPreviewProps) => {
  return (
    <div className="relative rounded-lg overflow-hidden border border-border/50 bg-muted/30">
      <div className="aspect-[3/2] relative bg-muted">
        <iframe
          src={location.embedUrl}
          className="w-full h-full border-0"
          loading="lazy"
          allowFullScreen
          referrerPolicy="no-referrer-when-downgrade"
          title={`Google Street View - ${location.label}`}
        />
        <div className="absolute bottom-2 left-2 flex items-center gap-1.5 bg-background/80 backdrop-blur-sm text-xs px-2 py-1 rounded text-foreground pointer-events-none">
          <MapPin className="w-3 h-3 text-primary" />
          {location.label}
        </div>
        <div className="absolute bottom-2 right-2 bg-background/80 backdrop-blur-sm text-xs px-2 py-1 rounded text-muted-foreground pointer-events-none">
          Revealed
        </div>
      </div>
    </div>
  );
};

export default LocationTargetPreview;
